import Uiconstants from '../../lib/UIconstants';
import AutoSpinController from '../../controllers/action_buttons/AutoSpinController';
import FastPlayController from '../../controllers/action_buttons/FastPlayController';

import { COMPONENTS } from '../../lib/constants';
import SpinButtonController from '../../controllers/action_buttons/SpinButtonController';
// import { isDesktop } from "react-device-detect";

// let scale = isDesktop ? 1 : 2;

export const SpinButtons = {
	name: COMPONENTS.SPIN_BUTTONS,
	position: {
		x: 1410,
		y: 855 - 86
	},
	controllers: [
		{
			Controller: AutoSpinController,
			name: Uiconstants.BTN_AUTO,
			config: {
				modal: Uiconstants.BTN_AUTO,
				item: COMPONENTS.AUTO_SPIN,
				infinity: 'infinite_icon',
				text: 'BTN_NUMBER_OF_BETS'
			}
		},
		{
			Controller: FastPlayController,
			name: Uiconstants.BTN_FASTPLAY,
			config: {
				btn: Uiconstants.BTN_FASTPLAY
			}
		},
		{
			Controller: SpinButtonController,
			name: 'SpinBtnController',
			config: {
				item: 'spin_stop'
			}
		}
	],

	components: [
		{
			name: 'holder',
			type: 'Sprite',
			components: [
				{
					name: 'spin_stop',
					type: 'Sprite',
					position: { x: 234, y: 86 },
					components: [
						{
							name: Uiconstants.BTN_SPIN,
							type: 'SpinButton',
							position: { x: 0, y: 0 },
							bg: 'spin_btn',
							bg_low: 'spin_btn_lowered',
							bg_icon: 'spin_icon',
							fg: 'stop_btn',
							fg_low: 'stop_btn_lowered',
							fg_icon: 'stop_icon'
						}
					]
				},
				{
					name: Uiconstants.BTN_FASTPLAY,
					type: 'ToggleButton',
					position: { x: 40, y: 48 + 86 },
					fg: 'blue_btn_lowered',
					fg2: 'red_btn_lowered',
					bg: 'btn_blue',
					icon: 'fast_icon_blue',
					iconActive: 'fast_icon_red'
				},
				{
					name: Uiconstants.BTN_AUTO,
					type: 'ToggleButton',
					position: { x: 40, y: 42 },
					fg: 'blue_btn_lowered',
					bg: 'btn_blue',
					fg2: 'red_btn_lowered',
					icon: 'auto_icon_blue',
					iconActive: 'auto_icon_red'
				}
			]
		}
	]
};
